/**
 * OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPage
 *
 * Page component for OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPage
 * Path: /docs/tutorials/intermediate/ui-patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateUiPatternsENDocScreenView as __OrbDocTutorialsIntermediateUiPatternsENDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsENDocScreenView';
import { OrbDocTutorialsIntermediateUiPatternsENDocAnalyticsView as __OrbDocTutorialsIntermediateUiPatternsENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPage(_props: OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Composing a screen from patterns","description":"Build a small dashboard from layout, data and feedback patterns, with tabs that switch the body.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/ui-patterns"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/ui-patterns"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/ui-patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateUiPatternsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateUiPatternsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsENOrbDocTutorialsIntermediateUiPatternsENPage;
